import { render } from "./UserCollections.vue?vue&type=template&id=23853342"
import script from "./UserCollections.vue?vue&type=script&lang=js"
export * from "./UserCollections.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__